export default __webpack_public_path__ + "static/media/excessViewing.32c50d33.svg";